import React from "react";
import { Tooltip } from "react-tippy";

import i18n from "i18n";
import { ParseDate, ParseDateTime } from "helpers/Parsers";

import OrderPills from "components/MainApp/atoms/Pills/OrderPills";

import styles from "./MainApp.organisms.Dashboard.Table.TableItem.module.scss";

const tooltipStyle = {
  background: "#FFFFFF",
  boxShadow: "0px 3px 6px #00000029",
  height: "45px",
  padding: "0 15px",
  color: "#494F66",
  fontFamily: "Roboto-Light",
  fontSize: "18px",
  borderRadius: "15px",
  display: "flex",
  alignItems: "center",
};

export const RequestOrderTableItem = ({ requestOrder, handleClick }) => {
  return (
    <div
      className={styles["dashboard-table-item-container"]}
      data-automation-id="product-item"
    >
      <div
        className={styles["dashboard-table-item-type"]}
        data-requestorder-id={requestOrder.id}
        data-requestorder-type={requestOrder.type}
        onClick={handleClick}
      >
        <Tooltip
          html={<div style={tooltipStyle}>{requestOrder.type}</div>}
          title={requestOrder.type}
          followCursor={true}
          position="left"
          offset={25}
        >
          {" "}
          <p>
            {i18n.t(`orders.types.${requestOrder.type}`)} /{" "}
            {i18n.t(`orders.klasses.${requestOrder.klass}`)}
          </p>
        </Tooltip>
      </div>
      <div
        className={styles["dashboard-table-item-code"]}
        data-requestorder-id={requestOrder.id}
        data-requestorder-type={requestOrder.type}
        onClick={handleClick}
      >
        <Tooltip
          html={<div style={tooltipStyle}>{requestOrder.code}</div>}
          title={requestOrder.code}
          followCursor={true}
          position="left"
          offset={25}
        >
          {" "}
          <p>{requestOrder.code}</p>
        </Tooltip>
      </div>
      <div
        className={styles["dashboard-table-item-date"]}
        data-requestorder-id={requestOrder.id}
        data-requestorder-type={requestOrder.type}
        onClick={handleClick}
      >
        <Tooltip
          html={
            <div style={tooltipStyle}>
              {requestOrder.created_at
                ? ParseDateTime(requestOrder.created_at)
                : null}
            </div>
          }
          followCursor={true}
          position="right"
          offset={25}
        >
          {" "}
          <p>
            {requestOrder.created_at ? ParseDate(requestOrder.created_at) : "-"}
          </p>
        </Tooltip>
      </div>
      <div
        className={styles["dashboard-table-item-owner"]}
        data-requestorder-id={requestOrder.id}
        data-requestorder-type={requestOrder.type}
        onClick={handleClick}
      >
        <Tooltip
          html={
            <div style={tooltipStyle}>
              <p>
                {requestOrder.owner
                  ? `${requestOrder.owner.first_name} ${requestOrder.owner.last_name}`
                  : "-"}
              </p>
            </div>
          }
          followCursor={true}
          position="right"
          offset={25}
        >
          <p>
            {requestOrder.owner
              ? `${requestOrder.owner.first_name} ${requestOrder.owner.last_name}`
              : "-"}
          </p>
        </Tooltip>
      </div>
      <div
        className={styles["dashboard-table-item-state"]}
        data-requestorder-id={requestOrder.id}
        data-requestorder-type={requestOrder.type}
        onClick={handleClick}
      >
        <Tooltip
          html={
            <div style={tooltipStyle}>
              <p>{i18n.t(`orders.status.${requestOrder.status}`)}</p>
            </div>
          }
          followCursor={true}
          position="right"
          offset={25}
        >
          <OrderPills state={requestOrder.status} />
        </Tooltip>
      </div>
      <div
        className={styles["dashboard-table-item-button"]}
        data-automation-id="select-requestOrder"
        data-requestorder-id={requestOrder.id}
        data-requestorder-type={requestOrder.type}
        onClick={handleClick}
      >
        <i className={styles["icon-chevron-derecha"]}></i>
      </div>
    </div>
  );
};

export default RequestOrderTableItem;
